/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

const _dsSetCookie = (name, value, days = 1, path = "/") => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    expires +
    "; path=" +
    path;
};

const _dsGetCookie = (name) => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

// Body Scroll Lock - iOS optimiert
let scrollPosition = 0;
let isScrollLocked = false;

const lockBodyScroll = () => {
  if (isScrollLocked) return;

  // Aktuelle Scroll-Position speichern
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  // Body fixieren
  const body = document.body;
  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollPosition}px`;
  body.style.width = '100%';

  // iOS-spezifisch: Touch-Events auf dem body blockieren
  body.addEventListener('touchmove', preventTouchMove, { passive: false });

  isScrollLocked = true;
};

const unlockBodyScroll = () => {
  if (!isScrollLocked) return;

  const body = document.body;
  const html = document.documentElement;

  // Touch-Event-Listener entfernen
  body.removeEventListener('touchmove', preventTouchMove, { passive: false });

  // Temporär smooth scrolling deaktivieren
  const previousScrollBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';

  // Body-Styles zurücksetzen
  body.style.removeProperty('overflow');
  body.style.removeProperty('position');
  body.style.removeProperty('top');
  body.style.removeProperty('width');

  // Scroll-Position sofort und sicher wiederherstellen
  // requestAnimationFrame stellt sicher, dass das Layout fertig ist
  requestAnimationFrame(() => {
    window.scrollTo(0, scrollPosition);

    // Scroll-Behavior nach kurzer Zeit wiederherstellen
    setTimeout(() => {
      if (previousScrollBehavior) {
        html.style.scrollBehavior = previousScrollBehavior;
      } else {
        html.style.removeProperty('scroll-behavior');
      }
    }, 10);
  });

  isScrollLocked = false;
};

const preventTouchMove = (e) => {
  // Erlaube Scrolling innerhalb des Cart-Drawers
  let target = e.target;
  while (target && target !== document.body) {
    if (target.classList && target.classList.contains('cart-drawer-inner')) {
      return;
    }
    target = target.parentElement;
  }
  // Blockiere alle anderen Touch-Moves
  e.preventDefault();
};

const dsCartDrawer = ({ freeShipping, gifts, upsells, allProducts }) => {
  return {
    cart: null,
    total_price: 0,
    total_price_after_discount: 0,
    total_price_without_discount: 0,
    total_discount: 0,
    allProducts: allProducts,
    upsells: upsells,
    upsellsAvailable: false,
    upsellProducts: [],
    discount: 0,
    upsellProduct: null,
    recommendations: {},
    itemsPaid: [],
    allPaidItems: [],
    freeShippingFromDiscountCode: false,
    itemsFree: [],
    discountCodeInput: null,
    validDiscountCode: null,
    codeStatus: null,
    discountedTotal: null,
    open: false,
    firstTimeOpened: false,
    shippingCost: 499,
    compareAtPricesFallback: [],
    loading: false,
    discountLoading: false,
    items: [],
    choiceOverlay: false,
    //Section Cart Gifts
    freeShipping: freeShipping,
    gifts: gifts,
    selectedGifts: [],
    giftChoiceOpen: false,
    alert: false,
    giftSelectionSuccessful: false,
    selectedFreeVariants: [],
    nextGift: null,
    //End Cart Gifts
    sortGiftsBy(prop) {
      return function (a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },
    giftAlreadyClaimed(giftProduct) {
      return this.items.find((s) => s.product_id == giftProduct.id);
    },
    isSelectableGift(item) {
      for (const gift of this.gifts) {
        if (
          gift.max != undefined &&
          gift.products.find((product) => product.id == item.product_id)
        ) {
          return true;
        }
      }
      return false;
    },
    getCompareAtPrice(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.compare_at_price;
      }
      
      const pFallback = this.compareAtPricesFallback.find((p) => {
        if (p.variantId == variant_id) {
          return true
        }
        return false
      })
      if (pFallback) {
        const { compareAtPrice } = pFallback
        return compareAtPrice * 100
      } 
      return false;
    },
    getTotalCompareAtPrice() {
      let total = 0;
      for (const item of this.items) {
        let compareAtPrice = this.getCompareAtPrice(item.variant_id);
        if (!compareAtPrice) compareAtPrice = item.price;
        if (compareAtPrice) {
          total += compareAtPrice * item.quantity;
        }
      }
      return total;
    },
    getTotalSavings() {
      return this.getTotalCompareAtPrice() - this.total_price;
    },
    getUnitPrice(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.unit_price;
      }
      return "";
    },
    getVariantTitle(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.variant_title;
      }
      return "";
    },
    widthBarStyle() {
      if (this.freeShippingFromDiscountCode) {
        return `width: 100%`;
      }
      return `width: ${this.widthShippingBar()}%`;
    },
    isFreeShippingActivated() {
      const width = this.widthShippingBar();
      if (this.freeShippingFromDiscountCode) {
        return true;
      }
      if (width < 100) {
        return false;
      }
      return true;
    },
    widthShippingBar() {
      // Versandfrei-Schwelle gilt (wie im Checkout) auf den rabattierten Betrag
      let total = this.total_price_after_discount;
      const freeShippingFrom = this.freeShipping.free_from;
      if (total >= freeShippingFrom) {
        return 100;
      }
      return Math.abs(parseInt(total) / freeShippingFrom) * 100;
    },
    calculateTotalPriceWithoutDiscount() {
      this.total_price_without_discount = this.getTotalCompareAtPrice();
    },
    giftsAlreadySelected(blockId) {
      for (let gift of this.gifts) {
        if (gift.id == blockId) {
          let giftsInCart = 0;
          for (const item of this.items) {
            const f = gift.products.find(
              (s) => s.variants[0].id == item.variant_id
            );
            if (f) {
              giftsInCart++;
            }
          }
          return giftsInCart >= gift.max;
        }
      }
      return false;
    },
    freeShippingAfter(money_format) {
      if (this.freeShippingFromDiscountCode) {
        return this.freeShipping.text_reached;
      }
      return this.total_price_after_discount >= this.freeShipping.free_from
        ? this.freeShipping.text_reached
        : this.giftDiff(money_format, this.freeShipping, null);
    },
    giftDiff(format, gift, nextGift) {
      //let total = this.total_price - this.discount;
      let total = this.total_price_after_discount;
      const diff = gift.free_from - total;
      const nextGiftDiff = nextGift?.free_from - total;
      const t = gift.text.replace("[money]", Shopify.formatMoney(diff, format));
      if (diff < 0) {
        return this.freeShipping.text_reached;
      }
      return t.includes("[next_money]")
        ? t.replace("[next_money]", Shopify.formatMoney(nextGiftDiff, format))
        : t;
    },
    addGiftProduct(giftProduct) {
      if (typeof ga !== "undefined") {
        ga("send", "event", "Cart", "CartUpsell");
      }
      CartJS.addItem(
        giftProduct.id,
        1,
        {},
        {
          error: function (jqXHR, textStatus, errorThrown) {},
        }
      );
    },
    hasFreeShipping() {
      const diff =
        this.freeShipping.free_from - (this.total_price - this.discount);
      if (diff < 0) {
        this.shippingCost = 0;
        return true;
      } else {
        this.shippingCost = this.freeShipping.shipping_costs;
        return false;
      }
    },
    checkMandatories(mandatoryProducts) {
      if (mandatoryProducts == undefined || mandatoryProducts.length == 0) {
        return true;
      }
      let foundCount = 0;
      let notFound = [];
      for (product of mandatoryProducts) {
        if (!this.items.find((s) => s.product_id == product.id)) {
          notFound.push(product);
        }
      }
      return notFound;
    },
    confirmGiftChoice() {
      if (this.selectedFreeVariants.length < this.maxFreeProducts) {
        const free = this.maxFreeProducts - this.selectedFreeVariants.length;
        if (free == 1) {
          alert("Du hast noch ein Geschenk frei");
        } else {
          alert("Du hast noch " + free + " Geschenke frei");
        }
        this.giftSelectionSuccessful = false;
      } else {
        this.giftSelectionSuccessful = true;
        this.choiceOverlay = false;

        let i = 1;
        // Remove other free gifts
        for (const item of this.items) {
          const f = this.selectedFreeVariants.find((s) => s == item.variant_id);
          if (item.price == 0 && !f) {
            CartJS.removeItem(i);
          }
          i++;
        }

        // Add gifts that are not added yet
        for (const variant_id of this.selectedFreeVariants) {
          let alreadyInCart = false;
          const f = this.items.find((item) => item.variant_id == variant_id);

          if (f) alreadyInCart = true;

          if (!alreadyInCart) {
            CartJS.addItem(variant_id, 1);
          }
        }
      }
    },
    changeGift(item) {
      const i = this.items.findIndex((s) => s.id == item.id);
      if (i > -1) CartJS.removeItem(i + 1);
      this.selectedFreeVariants = this.selectedFreeVariants.filter(
        (s) => s != item.variant_id
      );
      this.setGiftToUnfulfilled(item);
    },
    removeGift(item) {
      const i = this.items.findIndex((s) => s.product_id == item.id);
      if (i > -1) CartJS.removeItem(i + 1);
    },
    setGiftToUnfulfilled(item) {
      for (gift of this.gifts) {
        if (gift.products.find((product) => product.id == item.product_id)) {
          gift.fulfilled = false;
          return;
        }
      }
    },
    toggleFreeProduct(product) {
      if (!product.available) {
        return;
      }

      const variant = product.variants[0].id;

      if (this.selectedFreeVariants.indexOf(variant) == -1) {
        this.selectedFreeVariants.push(variant);
      } else {
        const index = this.selectedFreeVariants.indexOf(variant);
        if (index > -1) {
          //console.log("remove ", variant)
          this.selectedFreeVariants.splice(index, 1);
        }
      }
      if (this.selectedFreeVariants.length > this.nextGift.max) {
        this.selectedFreeVariants.splice(0, 1);
      }
    },
    isFreeProductSelected(product) {
      const f = this.selectedFreeVariants.find(
        (v) => v.toString() == product.variants[0].id.toString()
      );
      return !!f;
    },
    loadRecommendations() {
      for (const item of this.items) {
        if (!this.recommendations[item.product_id]) {
          this.recommendations[item.product_id] = [];
          const url = `/recommendations/products.json?product_id=${item.product_id}`;
          var $this = this;
          fetch(url)
            .then((response) => response.json())
            .then((data) => {
              console.log(data);
              $this.recommendations[item.product_id] = data?.products;
              if (data?.products?.length > 0) {
                $this.updateUpsellProduct();
              }
            });
        }
      }
    },
    updateUpsellProduct() {
      this.upsellProduct = null;

      var keys = Object.keys(this.recommendations);
      if (keys.length > 0) {
        for (let i = 0; i < 3; i++) {
          for (const product_id of Object.keys(this.recommendations)) {
            const products = this.recommendations[product_id];
            const hasProduct = this.items.find(
              (item) => item.product_id == product_id
            );

            if (hasProduct && !this.upsellProduct) {
              let newUpsellProduct;
              if (products.length > 0 && products[i]) {
                newUpsellProduct = products[i];
              }
              if (newUpsellProduct && this.cart && this.items.length > 0) {
                const cartProduct = this.items.find(
                  (item) => item.product_id == newUpsellProduct.id
                );

                if (!cartProduct) {
                  this.upsellProduct = newUpsellProduct;
                }
              }
            }
          }
        }
      }
    },
    loadImages() {
      for (const product of this.freeSelectableProducts) {
        fetch(
          `/search?view=id&type=product&q=${encodeURI(
            "id:" + product.productId
          )}`
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.products && response.products.length > 0) {
              if (response.products[0].title) {
                product.title = response.products[0].title;
              }
              product.image = response.products[0].featured_image;
              product.product_worth = response.products[0].product_worth;
              product.available = !!response.products[0].available;
            }
          })
          .catch((err) => {});
      }
    },
    checkFreeItem(item) {
      // Don't remove items that are 0€ due to automatic discounts (e.g., Function Studio bundles)
      if (item.discounts && item.discounts.length > 0) {
        return;
      }
      let foundInGifts = this.gifts.find((gift) =>
        gift.products.find((product) => product.id == item.product_id)
      );
      if (!foundInGifts) {
        CartJS.removeItemById(item.variant_id);
      }
    },
    async refreshCartData() {
      try {
        const response = await fetch("/cart.js");
        const cartData = await response.json();
        return cartData;
      } catch (error) {
        console.error("Failed to refresh cart data:", error);
        return null;
      }
    },

    async refreshCart() {
      try {
        // Refresh the cart data
        const cartData = await this.refreshCartData();
        if (cartData) {
          // Update the cart UI with the new data
          this.cart = cartData;
          this.total_price = cartData.total_price;
          this.items = cartData.items;
          // item.price = Originalpreis vor line-level Rabatt; nur echte Gratis-Items
          // (z.B. Geschenke mit Variant-Preis 0) sollen in itemsFree landen.
          // Auf 0€ rabattierte Items haben final_price=0 aber price>0 und werden
          // im itemsPaid-Block via item.final_price korrekt als "Gratis" gerendert.
          this.itemsPaid = cartData.items.filter((item) => item.price > 0);
          this.itemsFree = cartData.items.filter((item) => item.price == 0);

          // Check for discount applications
          // /cart.js liefert cart_level_discount_applications mit total_allocated_amount
          if (
            cartData.cart_level_discount_applications &&
            cartData.cart_level_discount_applications.length > 0
          ) {
            this.discount = cartData.cart_level_discount_applications.reduce(
              (total, discount) => {
                return total + (discount.total_allocated_amount || 0);
              },
              0
            );
          }
          // cart.total_price reflektiert bereits alle Rabatte (line-level + cart-level + Code)
          this.total_price_after_discount = cartData.total_price;
          this.total_discount = cartData.total_discount;
          if (cartData.original_total_price) {
            this.total_price_without_discount = cartData.original_total_price;
          }

          // Trigger cart:refresh event for other components
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Failed to refresh cart:", error);
      }
    },
    updateCart(cart) {
      console.log("updateCart called with cart:", cart);
      if (cart) {
        let discountCodeCookieCart;
        if (
          cart.discount_codes?.length > 0 &&
          cart.discount_codes[0].applicable
        ) {
          discountCodeCookieCart = cart.discount_codes[0].code;
        }

        var discountCodeCookie =
          _dsGetCookie("discount_code") || discountCodeCookieCart || "";
        console.log("Discount code from cookie:", discountCodeCookie);

        if (discountCodeCookie && !this.discountCodeInput) {
          this.discountCodeInput = discountCodeCookie;
          // Initialize discount code state from cookie
          this.validDiscountCode = discountCodeCookie;
          this.codeStatus = "valid";
          console.log(
            "Initialized discount code from cookie:",
            this.discountCodeInput
          );
        }

        this.cart = cart;
        this.total_price = cart.total_price;
        this.items = cart.items;
        console.log("Cart items:", this.items);

        this.itemsPaid = cart.items.filter((item) => item.price > 0);
        this.itemsFree = cart.items.filter((item) => item.price == 0);
        console.log(
          "Paid items:",
          this.itemsPaid.length,
          "Free items:",
          this.itemsFree.length
        );

        this.itemsFree.forEach((item) => this.checkFreeItem(item));
        this.loadRecommendations();
        const $this = this;

        setTimeout(() => {
          $this.loading = false;
          console.log("Loading set to false");
        }, 300);

        this.calculateTotalPriceWithoutDiscount();
        console.log(
          "Total price without discount:",
          this.total_price_without_discount
        );

        if (!$this.validDiscountCode) {
          console.log(
            "No valid discount code, calculating total after discount"
          );
          this.total_price_after_discount = this.total_price - this.discount;
          console.log(
            "Total price after discount:",
            this.total_price_after_discount
          );

          this.checkGiftClaims();
          this.checkUpsells();
        } else {
          console.log("Valid discount code exists:", $this.validDiscountCode);
        }

        // free_from liegt bereits in Cent vor; cart.total_price enthält alle Rabatte
        this.shippingCost =
          this.total_price >= this.freeShipping.free_from ? 0 : 499;
        console.log(
          "Shipping cost:",
          this.shippingCost,
          "Free shipping threshold:",
          this.freeShipping.free_from
        );

        this.discountedTotal = this.getDiscountedTotal();
        console.log("Discounted total:", this.discountedTotal);

        // Check if we have a discount code from the cookie and initialize discount amount
        // Hinweis: /cart.js liefert cart_level_discount_applications
        // (mit total_allocated_amount), NICHT discount_applications.
        if (
          discountCodeCookie &&
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0
        ) {
          this.discount = cart.cart_level_discount_applications.reduce(
            (total, discount) => {
              return total + (discount.total_allocated_amount || 0);
            },
            0
          );
          console.log("Total discount amount:", this.discount);
          this.codeStatus = "valid";
          this.validDiscountCode = discountCodeCookie;
        } else {
          console.log(
            "No discount applications found or no discount code cookie"
          );
        }

        // Shopify hat in cart.total_price bereits alle Rabatte abgezogen
        // (line-level + cart-level + Code) und liefert in cart.total_discount
        // den Gesamtrabatt sowie in cart.original_total_price den UVP.
        this.total_price_after_discount = cart.total_price;
        this.total_discount = cart.total_discount;
        if (cart.original_total_price) {
          this.total_price_without_discount = cart.original_total_price;
        }

        // Debug logging
        // console.log('=== CART DISCOUNT CALCULATION ===');
        // console.log('total_price_without_discount:', this.total_price_without_discount);
        // console.log('total_price:', this.total_price);
        // console.log('total_price_after_discount:', this.total_price_after_discount);
        // console.log('discount:', this.discount);
        // console.log('total_discount:', this.total_discount);
        // console.log('validDiscountCode:', this.validDiscountCode);
        // console.log('cart.total_discount (from Shopify):', this.cart.total_discount);
        // console.log('getTotalCompareAtPrice():', this.getTotalCompareAtPrice());
        // console.log('================================');

        // Kein automatischer triggerCheckout mehr: er erstellte bei jedem
        // Cart-Update einen parallelen Storefront-API-Cart (ohne Session-/
        // Attributions-Kontext) und überschrieb total_price_after_discount
        // mit dessen Total — Quelle der falschen Gesamtsumme im Drawer.
        // Einzige Wahrheitsquelle für die UI ist /cart.js.
      } else {
        console.log("updateCart called with no cart data");
      }
    },
    checkUpsells() {
      this.upsellProducts = [];
      let upsellsAvailable = false;
      for (const upsell of this.upsells) {
        for (const product of upsell.upsell_products) {
          if (this.upsellEligible(product, upsell.mandatory_products)) {
            const exist = this.upsellProducts.find(
              (item) => item.id == product.id
            );
            if (!exist && this.upsellProducts.length < 1)
              this.upsellProducts.push(product);

            upsellsAvailable = true;
          }
        }
      }
      console.log("upsellProducts", this.upsellProducts);

      return upsellsAvailable;
    },
    checkAutomaticGifts(gift) {
      const missingRequiredProducts = this.checkMandatories(
        gift.mandatory_products
      );
      let mandatoryAmountFulfilled = false;
      if (gift.mandatory_amount == "one") {
        mandatoryAmountFulfilled =
          missingRequiredProducts.length <= gift.mandatory_products.length - 1;
      } else {
        mandatoryAmountFulfilled = missingRequiredProducts.length == 0;
      }
      let codeMatches =
        gift.code != ""
          ? this.discountCodeInput
              ?.toUpperCase()
              ?.match(gift.code?.toUpperCase()) != null
          : true;

      //check if requiredProducts are in cart
      if (
        this.getDiscountedTotal() > gift.free_from * 100 &&
        mandatoryAmountFulfilled &&
        codeMatches
      ) {
        for (let product of gift.products) {
          const index = this.items.findIndex(
            (item) => item.product_id == product.id
          );
          if (index == -1) {
            this.addGiftProduct(product.variants[0]);
          }
        }
        gift.fulfilled = true;
        return;
      } else {
        gift.fulfilled = false;
        for (product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (index > -1) {
            this.removeGift(product);
            return true;
          }
          if (
            (this.nextGift != null &&
              !this.nextGift.fulfilled &&
              codeMatches &&
              this.nextGift?.free_from > gift.free_from) ||
            (this.nextGift == null && codeMatches) ||
            (this.nextGift != null && this.nextGift.fulfilled && codeMatches)
          ) {
            this.nextGift = gift;
            //CartJS.removeItem(index +1)
          }
        }
        if (!codeMatches) {
          gift.fulfilled = true;
          this.nextGift = undefined;
        }
      }
    },
    checkSelectedGifts(gift) {
      let fulfilled = false;
      let codeMatches =
        gift.code != ""
          ? this.discountCodeInput
              ?.toUpperCase()
              ?.match(gift.code?.toUpperCase()) != null
          : true;

      if (gift.code && !codeMatches) {
        return false;
      }
      const missingProductsInCart = this.checkMandatories(
        gift.mandatory_products
      );
      let mandatoryAmountFulfilled = false;
      if (gift.mandatory_amount == "one") {
        mandatoryAmountFulfilled =
          missingProductsInCart.length <= gift.mandatory_products.length - 1;
      } else {
        mandatoryAmountFulfilled = missingProductsInCart.length == 0;
      }

      if (gift.mandatory_products?.length == 0) {
        mandatoryAmountFulfilled = true;
      }
      /*console.log("codeMatches", gift.code, this.discountCodeInput, codeMatches);
      console.log("mandatoryAmountFulfilled", mandatoryAmountFulfilled, gift.mandatory_products)*/

      if (this.getDiscountedTotal() < gift.free_from * 100) {
        gift.variantPickable = mandatoryAmountFulfilled;
        for (product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (index > -1) {
            this.removeGift(product);
            fulfilled = false;
            gift.fulfilled = false;
            return true;
          }
          if (
            (this.nextGift != null &&
              codeMatches &&
              !this.nextGift.fulfilled &&
              this.nextGift?.free_from > gift.free_from) ||
            (this.nextGift == null && codeMatches)
          ) {
            this.nextGift = gift;
          }
          //CartJS.removeItem(index +1)
        }
      } else if (!mandatoryAmountFulfilled || !codeMatches) {
        for (product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (
            (this.nextGift != null &&
              codeMatches &&
              !this.nextGift.fulfilled &&
              this.nextGift?.free_from > gift.free_from) ||
            (this.nextGift == null && codeMatches)
          ) {
            this.nextGift = gift;
          }
          if (index > -1 || !mandatoryAmountFulfilled || !codeMatches) {
            this.removeGift(product);
            fulfilled = false;
            gift.fulfilled = false;
            return true;
          }
          return false;
        }
      } else {
        if (
          (this.nextGift != null &&
            codeMatches &&
            !this.nextGift.fulfilled &&
            this.nextGift?.free_from > gift.free_from) ||
          (this.nextGift == null && codeMatches)
        ) {
          if (!fulfilled) {
            this.nextGift = gift;
          }
        }

        //console.log(gift.code, gift.fulfilled, gift.free_from, this.nextGift?.free_from, this.nextGift?.fulfilled, codeMatches)
      }

      if (
        this.allGiftsInCart(gift) &&
        mandatoryAmountFulfilled &&
        codeMatches
      ) {
        fulfilled = true;
        if (this.nextGift == gift) {
          this.nextGift = null;
        }
        return false;
      }
      gift.fulfilled = fulfilled;
      return false;
    },
    getDiscountedTotal() {
      return this.discountedTotal && _dsGetCookie("discount_code")
        ? this.discountedTotal
        : this.total_price;
    },
    allGiftsInCart(gift) {
      let found = 0;
      for (product of gift.products) {
        const index = this.items.findIndex((s) => s.product_id == product.id);
        if (index > -1) {
          found++;
        }
      }
      return found == gift.max;
    },
    upsellEligible(item, mandatoryProducts) {
      let found = false;
      const index = this.items.findIndex((s) => s.product_id == item.id);
      if (index > -1) {
        found = true;
      }
      let missingProducts = this.checkMandatories(mandatoryProducts);
      return !found && missingProducts.length < mandatoryProducts.length;
    },
    checkGiftClaims() {
      let checked = false;
      for (let gift of this.gifts) {
        //console.log("check selectable gift", gift.code)
        if (gift.max != undefined) {
          checked = this.checkSelectedGifts(gift);
          //console.log("checked", checked)
          if (checked) return;
        } else {
          checked = this.checkAutomaticGifts(gift);
          //console.log("checked", checked)
          if (checked) return;
        }
      }
    },
    applyDiscountCode() {
      var $this = this;
      if (this.discountCodeInput && this.cart && this.items.length > 0) {
        this.discountLoading = true;

        let code = this.discountCodeInput;
        code = code.trim().toLowerCase();
        if (code && code.indexOf("?") > -1) {
          const codeSplit = code.split("?");
          code = codeSplit[0];
        }

        // Use the validateDiscountCode method to apply the discount code
        this.validateDiscountCode(code)
          .then((isValid) => {
            if (isValid) {
              // If the code is valid, update the UI
              $this.validDiscountCode = code.trim().toUpperCase();
              $this.discountCodeInput = code.trim().toUpperCase();
              $this.codeStatus = "valid";

              // Set cookies
              _dsSetCookie("discount_code", code.trim().toUpperCase(), 1);
              _dsSetCookie(
                "discount_code_referrer",
                code.trim().toUpperCase(),
                1
              );

              // Update UI elements
              var vdc = document.getElementById("cartDiscountCode");
              vdc && (vdc.value = code.trim().toUpperCase());

              var vd = document.getElementById("cartDiscount");
              vd && (vd.value = code.trim().toUpperCase());

              // Refresh cart to show updated prices
              this.refreshCart();

              // Check for gift claims and upsells
              setTimeout(() => {
                $this.checkGiftClaims();
                $this.checkUpsells();
              }, 500);
            } else {
              // If the code is invalid, show error
              $this.codeStatus = "invalid";
              $this.validDiscountCode = null;

              // Clear input fields
              var vdc = document.getElementById("cartDiscountCode");
              vdc && (vdc.value = "");

              var vd = document.getElementById("cartDiscount");
              vd && (vd.value = "");
            }

            $this.discountLoading = false;
          })
          .catch((error) => {
            console.error("Error applying discount code:", error);
            $this.codeStatus = "invalid";
            $this.validDiscountCode = null;
            $this.discountLoading = false;
          });
      }
    },
    // Add a function to check for existing discount code on page load
    checkExistingDiscountCode() {
      // Check if we have a discount code saved in cookie
      const savedCode = _dsGetCookie("discount_code");
      if (savedCode && savedCode.trim().length > 0) {
        console.log("Found saved discount code:", savedCode);
        this.validDiscountCode = savedCode;
        this.codeStatus = "valid";
        this.discountCodeInput = savedCode;

        // Refresh cart to get current discount information
        this.refreshCartData().then((cart) => {
          if (cart.total_discount > 0) {
            this.total_discount = cart.total_discount;
            this.total_price_after_discount = cart.total_price;
          }

          // Check for free shipping discount
          if (
            cart.cart_level_discount_applications &&
            cart.cart_level_discount_applications.length > 0
          ) {
            const hasFreeShipping = cart.cart_level_discount_applications.some(
              (discount) =>
                discount.type === "shipping" ||
                (discount.value_type === "percentage" && discount.value === 100)
            );

            if (hasFreeShipping) {
              this.freeShippingFromDiscountCode = true;
              this.shippingCost = 0;
            }
          }
        });
      }
    },
    async validateDiscountCode(code) {
      console.log("validateDiscountCode called with code:", code);
      if (!code || code.trim().length === 0) {
        console.log("Invalid code: empty or whitespace");
        return false;
      }

      const formattedCode = code.trim().toUpperCase();

      console.log("formattedCode", formattedCode);
      console.log("validDiscountCode", this.validDiscountCode);

      // Check if this code is already applied
      if (formattedCode === this.validDiscountCode) {
        console.log("Code already exists:", formattedCode);
        this.codeStatus = "exist";
        this.discountLoading = false;
        return true;
      }

      // Speichere den aktuellen gültigen Code, falls vorhanden
      const previousValidCode = this.validDiscountCode;

      try {
        // Set loading state
        this.discountLoading = true;
        const shopUrl = window.location.hostname;

        // Hole den aktuellen Warenkorb vor der Anwendung des neuen Codes
        const cartBefore = await this.refreshCartData();
        const previousDiscount = cartBefore.total_discount;
        const previousDiscountApplications =
          cartBefore.cart_level_discount_applications || [];

        // Apply the discount code directly
        console.log(
          "Applying discount code via URL:",
          `https://${shopUrl}/discount/${formattedCode}`
        );

        await fetch(`https://${shopUrl}/discount/${formattedCode}`, {
          method: "GET",
          mode: "no-cors",
          credentials: "include",
        });

        // Get the updated cart to reflect any discounts
        const cart = await this.refreshCartData();

        // Speichere den aktuellen Zustand des Warenkorbs
        const currentDiscount = cart.total_discount;
        const hasDiscountApplications =
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0;

        // Prüfe, ob der Rabattcode gültig ist
        if (currentDiscount > 0 || hasDiscountApplications) {
          console.log("Discount code was applied successfully");

          // Store the discount information
          this.total_discount = cart.total_discount;
          this.total_price_after_discount = cart.total_price;

          // Update discount status
          this.codeStatus = "valid";
          this.validDiscountCode = formattedCode;

          // Save the discount code to a cookie for persistence
          // _dsSetCookie("discount_code", formattedCode, 1);

          // Check for free shipping discount
          const hasFreeShipping =
            hasDiscountApplications &&
            cart.cart_level_discount_applications.some(
              (discount) =>
                discount.type === "shipping" ||
                (discount.value_type === "percentage" && discount.value === 100)
            );

          if (hasFreeShipping) {
            this.freeShippingFromDiscountCode = true;
            this.shippingCost = 0;
          }

          // Check for gift eligibility after applying discount
          this.checkGiftClaims();

          // CartJS-State synchronisieren: der Code wurde per fetch an CartJS
          // vorbei angewendet. Ohne Sync hält CartJS.cart noch die Totals von
          // vor dem Rabatt und jedes spätere cart-update-Event würde sie
          // wieder in die UI schreiben.
          if (window.CartJS) {
            CartJS.getCart();
          }

          this.discountLoading = false;
          return true;
        } else {
          // Wenn der Code ungültig ist
          console.log("Invalid discount code");

          // Wenn es einen vorherigen gültigen Code gab, diesen wiederherstellen
          if (previousValidCode) {
            console.log("Restoring previous valid code:", previousValidCode);

            // Entferne den ungültigen Code
            await fetch(`https://${shopUrl}/discount/clear`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Warte kurz, damit der Clear-Befehl wirksam wird
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Wende den vorherigen gültigen Code wieder an
            await fetch(`https://${shopUrl}/discount/${previousValidCode}`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Behalte den vorherigen Status bei
            this.validDiscountCode = previousValidCode;
            this.codeStatus = "valid";

            // CartJS-State mit dem wiederhergestellten Code synchronisieren
            if (window.CartJS) {
              CartJS.getCart();
            }

            // Zeige Fehlermeldung für den neuen ungültigen Code
            this.tempInvalidCode = formattedCode;

            this.tempInvalidCode = null;
          } else {
            // Wenn es keinen vorherigen Code gab, setze auf "invalid"
            this.codeStatus = "invalid";
            this.validDiscountCode = null;
          }

          this.discountLoading = false;
          return false;
        }
      } catch (error) {
        console.error("Error validating discount code:", error);

        // Bei Fehler den vorherigen Code wiederherstellen, falls vorhanden
        if (previousValidCode) {
          try {
            const shopUrl = window.location.hostname;

            // Entferne den ungültigen Code
            await fetch(`https://${shopUrl}/discount/clear`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Warte kurz, damit der Clear-Befehl wirksam wird
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Wende den vorherigen gültigen Code wieder an
            await fetch(`https://${shopUrl}/discount/${previousValidCode}`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Behalte den vorherigen Status bei
            this.validDiscountCode = previousValidCode;
            this.codeStatus = "valid";

            // CartJS-State mit dem wiederhergestellten Code synchronisieren
            if (window.CartJS) {
              CartJS.getCart();
            }
          } catch (restoreError) {
            console.error(
              "Error restoring previous discount code:",
              restoreError
            );
          }
        } else {
          this.codeStatus = "invalid";
          this.validDiscountCode = null;
        }

        this.discountLoading = false;
        return false;
      }
    },
    async refreshCartData() {
      try {
        const response = await fetch("/cart.js");
        if (!response.ok) {
          throw new Error(
            `Failed to fetch cart: ${response.status} ${response.statusText}`
          );
        }
        return await response.json();
      } catch (error) {
        console.error("Error fetching cart data:", error);
        throw error;
      }
    },
    decreaseQuantity(item) {
      this.loading = true;
      const index = this.items.findIndex((cartItem) => cartItem.key == item.key);
      CartJS.updateItem(index + 1, item.quantity - 1);
    },
    removeItem(item) {
      CartJS.updateItem(index + 1, item);
    },
    increaseQuantity(item) {
      this.loading = true;
      const index = this.items.findIndex((cartItem) => cartItem.key == item.key);
      CartJS.updateItem(index + 1, item.quantity + 1);
    },
    removeItem(item) {
      this.loading = true;
      const index = this.items.findIndex((cartItem) => cartItem.key == item.key);
      CartJS.removeItem(index + 1);
    },
    initialize(cart) {
      var $this = this;

      try {
        this.compareAtPricesFallback = JSON.parse(document.getElementById('CartCompareAtPrices').innerHTML);
        console.log("CompareAtPrices", this.compareAtPricesFallback);
      } catch (err) {

      }

      this.$watch("open", (value) => {
        if (value && !$this.firstTimeOpened) {
          $this.firstTimeOpened = true;
        }

        const trans = document.getElementById("rawa-container");
        if (trans) {
          if (value) {
            trans.style.display = "none";
          } else {
            trans.style.display = "block";
          }
        }

        const trustedBadge = document.querySelector(
          "[id^='trustbadge-container']"
        );
        if (trustedBadge) {
          if (value) {
            trustedBadge.style.display = "none";
          } else {
            trustedBadge.style.display = "block";
          }
        }

        // iOS-optimierte Scroll-Sperrung
        if (value) {
          lockBodyScroll();
        } else {
          unlockBodyScroll();
        }
      });

      this.gifts = this.gifts.sort(this.sortGiftsBy("free_from"), "desc");
      if (!cart) return;
      this.updateCart(cart);
    },
    calculateSavings() {
      const comparePrices = this.itemsPaid
        .map((item) => item.price * item.quantity)
        .reduce((a, b) => a + b, 0);
      const realPrices = this.total_price - this.discount;
      return comparePrices - realPrices;
    },
    triggerCheckout(code) {
      const $this = this;
      $this.discountLoading = true;

      // Vorbereiten der Warenkorb-Items für die Cart API
      const lineItems = this.itemsPaid.map((paidItem) => ({
        merchandiseId: `gid://shopify/ProductVariant/${paidItem.variant_id}`,
        quantity: paidItem.quantity,
      }));

      // Storefront API-Token aus den Metadaten holen
      const storefrontAccessToken = document
        .querySelector('meta[name="shopify-storefront-api-token"]')
        ?.getAttribute("content");

      if (!storefrontAccessToken) {
        console.error("Fehler: Storefront API-Token nicht gefunden");
        $this.discountLoading = false;
        return;
      }

      // GraphQL-Mutation zum Erstellen eines Carts
      const createCartMutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      // Sende Anfrage an die Storefront API
      fetch("https://" + window.location.host + "/api/2023-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
          query: createCartMutation,
          variables: {
            input: {
              lines: lineItems,
            },
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data?.cartCreate?.cart) {
            const cartId = data.data.cartCreate.cart.id;
            const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;

            // Wenn ein Rabattcode vorhanden ist, diesen anwenden
            if (code) {
              return applyDiscountAndRedirect(cartId, checkoutUrl, code);
            } else {
              // Direkt zum Checkout weiterleiten
              window.location.href = checkoutUrl;
              $this.discountLoading = false;
            }
          } else {
            console.error(
              "Fehler beim Erstellen des Carts:",
              data.errors || data.data?.cartCreate?.userErrors
            );
            $this.discountLoading = false;
          }
        })
        .catch((error) => {
          console.error("Fehler beim Checkout-Vorgang:", error);
          $this.discountLoading = false;
        });

      // Funktion zum Anwenden des Rabattcodes und Weiterleiten
      function applyDiscountAndRedirect(cartId, checkoutUrl, discountCode) {
        const discountMutation = `
          mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
            cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
              cart {
                id
                checkoutUrl
                discountCodes {
                  code
                  applicable
                }
                cost {
                  totalAmount {
                    amount
                  }
                  subtotalAmount {
                    amount
                  }
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `;

        return fetch(
          "https://" + window.location.host + "/api/2023-07/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            },
            body: JSON.stringify({
              query: discountMutation,
              variables: {
                cartId: cartId,
                discountCodes: [discountCode],
              },
            }),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.data?.cartDiscountCodesUpdate?.cart) {
              const cart = data.data.cartDiscountCodesUpdate.cart;

              const applicable = cart.discountCodes.some((dc) => dc.applicable);

              if (applicable) {
                // WICHTIG: Keine Preis-/Rabatt-Werte aus diesem Storefront-API-
                // Cart in die UI übernehmen! Es ist ein paralleler Cart ohne
                // Session-/Attributions-Kontext — seine Totals weichen vom
                // echten Ajax-Cart (/cart.js) ab und haben früher die
                // Gesamtsumme im Drawer überschrieben.
                $this.validDiscountCode = discountCode.trim().toUpperCase();
                $this.codeStatus = "valid";

                // Save the discount code to a cookie for persistence
                // _dsSetCookie(
                //   "discount_code",
                //   discountCode.trim().toUpperCase(),
                //   1
                // );

                // Update UI elements
                var vdc = document.getElementById("cartDiscountCode");
                vdc && (vdc.value = discountCode.trim().toUpperCase());

                var vd = document.getElementById("cartDiscount");
                vd && (vd.value = discountCode.trim().toUpperCase());

                // Prüfe Geschenkansprüche mit dem neuen Rabatt
                setTimeout(() => {
                  $this.checkGiftClaims();
                  $this.checkUpsells();
                }, 100);
              } else {
                // Rabattcode ist nicht anwendbar
                $this.codeStatus = "invalid";
                $this.discount = 0;
                $this.validDiscountCode = null;

                // Leere Eingabefelder
                var vdc = document.getElementById("cartDiscountCode");
                vdc && (vdc.value = "");

                var vd = document.getElementById("cartDiscount");
                vd && (vd.value = "");
              }

              // Zum Checkout weiterleiten
              // window.location.href = cart.checkoutUrl;
            } else {
              // Bei Fehlern trotzdem weiterleiten
              // window.location.href = checkoutUrl;
            }
            $this.discountLoading = false;
          })
          .catch((error) => {
            console.error("Fehler beim Anwenden des Rabattcodes:", error);
            // Bei Fehler trotzdem zum Checkout weiterleiten
            window.location.href = checkoutUrl;
            $this.discountLoading = false;
          });
      }
    },
  };
};

function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

// AS BE-0061 START — robuste Variante mit Event-Delegation
document.addEventListener("click", function (e) {
  const button = e.target.closest(".as-be-0061-copyBtn");
  if (!button) return;

  const parent = button.closest(".be-0061-copy");
  if (!parent) return;

  const img = parent.querySelector(".be-0061-copy-svg");
  const copyText = parent.querySelector(".be-0061-copyBtn");
  const copiedMessage = parent.querySelector(".be-0061-copiedBtn");
  const code = copyText.textContent.trim();

  const showCopied = () => {
    img.style.display = "none";
    copyText.style.display = "none";
    copiedMessage.style.display = "flex";
    setTimeout(() => {
      copiedMessage.style.display = "none";
      img.style.display = "flex";
      copyText.style.display = "flex";
    }, 2000);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(code).then(showCopied).catch(() => fallbackCopy(code, showCopied));
  } else {
    fallbackCopy(code, showCopied);
  }
});

function fallbackCopy(code, onSuccess) {
  const ta = document.createElement("textarea");
  ta.value = code;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
    onSuccess();
  } catch (err) {
    alert("Kopieren fehlgeschlagen: " + err);
  }
  document.body.removeChild(ta);
}
// AS BE-0061 END
